<template>
  <div>
    <swiper v-if="homeSwiper.length > 1 " class="banner-box" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in homeSwiper" :key="index" class="banner-box" :data-jump-url="item.jumpUrl" style="overflow:hidden">
        <img :src="cfg.imageDomain + item.thumbnailPath" alt="" :data-jump-url="item.jumpUrl">
      </swiper-slide>
    </swiper>
    <div v-else class="banner-box" style="overflow:hidden">
      <img v-if="homeSwiper[0]" :src="cfg.imageDomain + homeSwiper[0].thumbnailPath" alt="" @click="advertJump(homeSwiper[0].customUrl)">
    </div>
  </div>
</template>

<script>
import { getAdvert } from '@/api/common';
const HOME_SWIPER = 0 // 首页图片轮播
export default {
  name: 'Banner',
  data() {
    const _this = this;
    return {
      homeSwiper: [],
      swiperOptions: {
        autoplay: true,
        loop: true,
        effect: 'fade',
        on: {
          click(e) {
            const jumpUrl = e.target.dataset.jumpUrl;
            if (jumpUrl) {
              _this.advertJump(jumpUrl);
            }
          }
        }
      }
    }
  },
  mounted() {
    getAdvert(HOME_SWIPER).then(res => {
      this.homeSwiper = res.data;
    })
  },
  methods: {
    advertJump(applink) {
      if (applink.indexOf('http') === -1) {
        this.$router.push({
          path: applink
        })
      } else {
        var windowOpen = window.open()
        windowOpen.location = applink;
      }
    }
  }
}
</script>

<style lang="less" scoped>
    .banner-box {
        width: 100%;
        overflow: hidden;
        img {
            width: 100%;
            display: block;
            max-height: 258.92px;
            vertical-align: middle;
        }
    }
</style>
